import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDPBtVbSObgmh3B2ZYD91Dou20MIptv4uQ",
  authDomain: "turemedicine-g1d8dc.firebaseapp.com",
  projectId: "turemedicine-g1d8dc",
  storageBucket: "turemedicine-g1d8dc.firebasestorage.app",
  messagingSenderId: "692894251353",
  appId: "1:692894251353:web:db60fe5d7775dededb7448"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);